import { useEffect, useState } from 'react';
import OdfjellInputComponent from '../odfjell-input-component/OdfjellInputComponent';
import { useConnectionStore } from 'src/context/ConnectionContext';
import useSyncOfflineData from 'src/utils/connectivity/useSyncOfflineData';

export const OfflineSelectionComponent: React.FC = () => {
    const { isOfflineSimulated, setIsOfflineSimulated } = useConnectionStore();
    const [_isOfflineSimulated, _setIsOfflineSimulated] = useState<boolean>(false);
    const { syncOfflineData } = useSyncOfflineData();

    useEffect(() => {
        const getIsOfflineSimulated = async () => {
            const value = await isOfflineSimulated();
            _setIsOfflineSimulated(value);
        };
        getIsOfflineSimulated();
    }, []);

    const onOfflineChange = () => {
        _setIsOfflineSimulated(!_isOfflineSimulated);
        setIsOfflineSimulated(!_isOfflineSimulated);

        if (_isOfflineSimulated) {
            syncOfflineData();
        }
    };
    return (
        <>
            <h4>Offline</h4>
            <OdfjellInputComponent
                type="checkbox"
                description="Simulate offline"
                name="OfflineSelect"
                value={_isOfflineSimulated}
                onChange={onOfflineChange}
            />
        </>
    );
};
